const mutations = {
  changeWelcomeMsg (state, newWelcomeMsg) {
    state.newWelcomeMsg = newWelcomeMsg
  },
  setUser (state, info) {
    state.user.name = info.name
    state.user.email = info.email
  },
  refreshLoggedIn (state) {
    state.user.isLoggedIn = !!localStorage.getItem('authToken')
  }
}
export default mutations
